<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h1 text-white d-inline-block mb-0 header fw-500">
            {{ productName }} Policies
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <!-- <route-bread-crumb></route-bread-crumb> -->
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <div class="mt--6 px-2 px-sm-4">
      <div>
        <div class="bg-white rounded-bottom change-color">
          <div>
            <b-col cols="12" class="pt-3 d-flex flex-wrap bg-white rounded-top">
              <el-select
                class="select-primary pagination-select mb-3 mr-3"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="mr-3">
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                  v-on:input="resetPagination()"
                >
                </base-input>
              </div>

              <div>
                <base-button
                  type="danger"
                  class="btn-refresh"
                  @click="refreshData()"
                >
                  <b-icon icon="arrow-repeat"></b-icon>
                </base-button>
              </div>
            </b-col>
            <el-table
              :data="queriedData"
              row-key="_id"
              :default-sort="{
                prop: 'quote_created_date',
                order: 'descending'
              }"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              v-loading="loading"
            >
              <el-table-column type="expand">
                <template #default="props">
                  <b-row class="px-5 expandedPolicy">
                    <b-col cols="6" md="8">
                      <b-row>
                        <b-col cols="5">
                          <p>Created Date:</p>
                          <p>Insured Contact Name:</p>
                          <p>Insured Email:</p>
                          <p>Number Of Vehicles:</p>
                          <p>Business Description:</p>
                        </b-col>
                        <b-col cols="7">
                          <p>
                            {{
                              formatDateTime(props.row.quote_created_date)
                            }}
                          </p>
                          <p>
                            {{ props.row.Customer_contact_first_name }}
                            {{ props.row.Customer_contact_last_name }}
                          </p>
                          <p>{{ props.row.Customer_contact_email }}</p>
                          <p>
                            {{ getMotorVehicleCount(props.row) }}
                          </p>
                          <p>
                            {{ getBusinessDescriptionLabel(props.row) }}
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="1"></b-col>

                    <b-col cols="6" md="3">
                      <b-row class="pl-2" align-h="center">
                        <b-col
                          cols="auto"
                          md="12"
                          class="mb-4"
                          v-for="doc in visibleMotorPolicyDocuments"
                          :key="doc.type"
                        >
                          <base-button
                            @click.native="downloadMotorDocument(props.row, doc.type)"
                            class="edit"
                            type="danger"
                            size="sm"
                            icon
                            v-b-tooltip.hover
                            title="Download PDF"
                          >
                            <i class="fas fa-file-download btn-download"
                              ><span> {{ doc.label }}</span></i
                            >
                          </base-button>
                        </b-col>
                      </b-row>
                    </b-col>

                  </b-row>
                </template>
              </el-table-column>

              <el-table-column
                label="Upload"
                min-width="100px"
                v-if="hasUploadPermission"
              >
                <div
                  slot-scope="{ row }"
                  tabindex="0"
                  v-b-tooltip.hover
                >
                  <base-button
                    @click.native="showUploadDialog(row)"
                    class="edit"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <b-icon font-scale="2" icon="upload"></b-icon>
                  </base-button>
                </div>
              </el-table-column>

              <el-table-column
                label="Status"
                min-width="200px"
                prop="Status"
                sortable
              >
                <template slot-scope="scope">
                  <span
                    :class="statusPillClass(scope.row.motorQuoteStatusRaw)"
                    :title="scope.row.Status"
                    >{{ scope.row.Status }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                label="Business Name"
                prop="Customer_insured_name"
                min-width="150px"
                sortable
              >
              </el-table-column>

              <el-table-column
                label="Total Premium"
                prop="finalTotalPayable"
                min-width="150px"
                :formatter="row => formatPremium(row)"
                sortable
              >
              </el-table-column>

              <el-table-column
                label="Quote Ref"
                min-width="130px"
                prop="Quote_Ref_No"
                sortable
              >
              </el-table-column>

              <el-table-column
                label="Broker Name"
                min-width="180px"
                prop="Broker_Name"
                sortable
              >
              </el-table-column>

              <el-table-column
                label="Broker Organization"
                min-width="180px"
                prop="Broker_Org_Name"
                sortable
              >
              </el-table-column>

              <template #empty>
                <p>{{ loading ? "" : "No Data" }}</p>
              </template>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap py-3 px-5"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :value="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </div>
      </div>
      <dialog-upload-document
        v-on:modelPopupCancel="modelPopupCancel"
        v-on:handleCallAPI="handleCallAPI"
        :acceptedQuote="acceptedQuote"
        :titleDialog="titleDialog"
        :quoteScheduleModal="quoteScheduleModal"
      />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Scrollbar } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../../components/PaginatedTables/clientPaginationMixin";
import { GlobalStore } from "../../globalStore";
import { formattingMethods } from "../../helpers/formatting";
import { appFunctions } from "../../helpers/appFunctions";
import { toasts } from "../../helpers/toasts";
import {
  motorQuoteStatus,
  getMotorQuoteStatusLabel,
  getMotorQuoteStatusPillClass
} from "../../constants/motorQuoteStatus";
import { entsiaDropDowns } from "../../assets/data/entsiaLOVs";
import { downloadPDFFromBase64 } from "../../helpers/common";
import DialogUploadDocument from "../components/DialogUploadDocument.vue"

export default {
  data() {
    return {
      tableData: [],
      selectedRows: [],
      quotesList: [],
      productCode: '',
      loading: false,
      titleDialog: '',
      quoteScheduleModal: '',
      acceptedQuote: {},
      uploadedQuoteId: '',
      hasUploadPermission: false,
      motorPolicyDocuments: [
        {
          type: "lm-gti-transport-certificate-of-currency-combined",
          label: "Cert of Currency",
        },
        {
          type: "lm-gti-transport-policy-schedule-client",
          label: "Policy Schedule",
        },
        {
          type: "lm-tax-invoice-policy-schedule",
          label: "Tax Invoice",
        },
        {
          type: "lm-gti-transport-disclosure-details",
          label: "Disclosure Details",
        },
      ],
    };
  },
  computed: {
    productName() {
      return formattingMethods.formatProductNameVIBS(this.$route.params.productName)
    },
    isInsuranceBroker() {
      return !!(
        GlobalStore.brokerObj &&
        GlobalStore.brokerObj.parentOrg &&
        GlobalStore.brokerObj.parentOrg.is_insurance_broker
      );
    },
    /** Finance brokers only get Cert of Currency; other PDFs are insurance-desk only. */
    visibleMotorPolicyDocuments() {
      if (this.isInsuranceBroker) {
        return this.motorPolicyDocuments;
      }
      return this.motorPolicyDocuments.filter(
        doc => doc.type === "lm-gti-transport-certificate-of-currency-combined"
      );
    },
  },
  methods: {
    showUploadDialog(row) {
      this.title = null
      this.titleDialog = `Policy - Quote Ref ${row.Quote_Ref_No}`
      const offered = row.offeredQuotes || []
      this.acceptedQuote = offered.find(quote => quote.status == "Accepted")
      this.uploadedQuoteId = row.Jotform_quote_id
      this.quoteScheduleModal = true
    },

    modelPopupCancel() {
      this.quoteScheduleModal = false
    },

    async handleCallAPI(documents) {
      await appFunctions.crud_customerPolicy("updateDocuments", {
          uploadedQuoteId: this.uploadedQuoteId,
          documents: documents
        })
        .then(resp => {
          this.fetchData()
          this.quoteScheduleModal = false
        })
        .catch((error) => {
          this.quoteScheduleModal = false
          toasts.error("Update policy error!")
        })
    },

    checkProductCode() {
      const productCodes = {
        plantEquipment: "YIHQ-PE",
        motor: "YIHQ-MOTOR",
        otherAssets: "YIHQ-OTHER-ASSETS",
        property: "YIHQ-PROPERTY",
        jotformPELive: "YIHQ-PELIVE",
        psLive: "YIHQ-PSLIVE",
        motorLive: "YIHQ-MOTORLIVE"
      }
      console.log("product name: " + this.$route.params.productName);
      this.productCode = productCodes[this.$route.params.productName]
    },

    formatData(offeredQuotes) {
      offeredQuotes.basePremium = offeredQuotes.basePremium ? "$" + formattingMethods.numberWithCommas(offeredQuotes.basePremium) : ""
      offeredQuotes.ESL = offeredQuotes.ESL ? "$" + formattingMethods.numberWithCommas(offeredQuotes.ESL) : ""
      offeredQuotes.policyFee = offeredQuotes.policyFee ? "$" + formattingMethods.numberWithCommas(offeredQuotes.policyFee) : ""
      offeredQuotes.totalPayable = offeredQuotes.totalPayable ? "$" + formattingMethods.numberWithCommas(offeredQuotes.totalPayable) : ""
      return offeredQuotes
    },

    paginationChanged(page) {
      this.pagination.currentPage = page;
    },

    formatDate(dateVal) {
      return formattingMethods.formatDate(dateVal);
    },

    formatDateTime(dateVal) {
      if (dateVal == null || dateVal === "" || dateVal === "N/A") {
        return "N/A";
      }
      return formattingMethods.formatDateTime(dateVal);
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },

    statusPillClass(raw) {
      return getMotorQuoteStatusPillClass(raw);
    },

    /**
     * Format the premium amount to include commas and dollar symbol.
     * @param {Object} row - row data.
     * @returns {String} - formatted amount.
     */
    formatPremium(row) {
      const premium = row.finalTotalPayable;
      if (premium == null || premium === "" || premium === "N/A") {
        return "N/A";
      }
      return "$" + formattingMethods.numberWithCommas(premium);
    },

    getMotorVehicleCount(row) {
      const list = this.getSafe(
        () =>
          row.Data_obj.messageData.policy.commercialMotorSubproduct
            .vehiclesAndGoods.listOfVehicles
      );
      if (list === "N/A" || list == null) {
        return "N/A";
      }
      if (Array.isArray(list)) {
        return list.length;
      }
      return "N/A";
    },

    getBusinessDescriptionLabel(row) {
      const candidates = [
        row.businessDesc,
        this.getSafe(
          () =>
            row.Data_obj.messageData.policy.sharedLiabilitySubproduct
              .generalBusinessDetails.businessDescription
        ),
        this.getSafe(
          () =>
            row.Data_obj.messageData.policy.commercialMotorSubproduct
              .generalMotorDetails.occupationCode
        ),
        row.Customer_business_description,
      ];
      const code = candidates.find((value) => value && value !== "N/A");

      if (!code) {
        return "N/A";
      }

      const option = entsiaDropDowns.businessDescriptionsOptions.find(
        (item) => item.value === code
      );
      return option?.label || code;
    },

    getMotorPolicyAttachmentId(row) {
      return row.Customer_policy_guid || row.Customer_policy_id;
    },

    async downloadMotorDocument(row, type) {
      const policyId = this.getMotorPolicyAttachmentId(row);
      if (!policyId) {
        toasts.error("Unable to download document for this policy.");
        return;
      }

      try {
        const pdf = await appFunctions.getFileAttachment(
          "getPolicyFileAttachment",
          { policy_id: policyId, type }
        );

        if (!pdf || !pdf.fileContent) {
          toasts.error(
            "Documents are currently being generated - try again shortly"
          );
          return;
        }

        const fileContent = String(pdf.fileContent);
        if (fileContent.startsWith("data:")) {
          const downloadLink = document.createElement("a");
          downloadLink.href = fileContent;
          downloadLink.download = pdf.filename || `${type}.pdf`;
          downloadLink.click();
          return;
        }

        downloadPDFFromBase64(fileContent, pdf.filename || `${type}.pdf`);
      } catch (error) {
        console.error("downloadMotorDocument failed", error);
        toasts.error(
          "Documents are currently being generated - try again shortly"
        );
      }
    },

    formatOfferedQuoteTitle(quote) {
      const totalPayable = "$" + formattingMethods.numberWithCommas(quote.totalPayable)
      return `Quote Schedule - Total Payable: ${totalPayable}`
    },

    fetchData() {

console.log("product: " + this.productCode);

      this.loading = true;
      appFunctions
        .crud_customerPolicy("listByRealmId", {
          Realm_user_id: GlobalStore.brokerObj.Realm_user_id,
          type: "policy",
          productCode: "YIHQ-MOTORLIVE"
        })
        .then(resp => {
          var tdata = resp.data.data;
          const isPartner = resp.data.isPartner
          // only special partners can upload documents
          if (isPartner) {
            this.hasUploadPermission = true
          }

          tdata.forEach(q => {
            // Formatting number values.
            q.status = false;

            if (!!!q.Status) {
              q.Status = "Not Started";
              // q.Ubind_refNo = "N/A";
            }

            const statusRaw = q.Status;

            if (statusRaw === "Accepted") {
              q.Status = "Active";
            }

            q.motorQuoteStatusRaw = statusRaw;

            const premium =
              q.Data_obj && q.Data_obj.totalPremiumIncFees != null
                ? q.Data_obj.totalPremiumIncFees
                : null;
            q.finalTotalPayable = premium != null && premium !== "" ? premium : "N/A";
            q.Broker_Name = q.createdByName;

            const labelSource =
              statusRaw === "Accepted" ? "Active" : statusRaw;
            q.Status = getMotorQuoteStatusLabel(labelSource);
          });

          tdata = tdata.filter(
            row => row.motorQuoteStatusRaw === motorQuoteStatus.policyBound
          );

          tdata.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return (
              new Date(b.quote_created_date) -
              new Date(a.quote_created_date)
            );
          });

          this.tableData = tdata;

          this.initFuse([
            "Customer_insured_name",
            "Quote_Ref_No",
            "Status",
            "Broker_Name",
            "Broker_Org_Name"
          ]);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    refreshData() {
      this.resetPagination();
      this.searchQuery = "";
      this.tableData = [];
      this.fetchData();
    },
  },
  watch: {
    productName() {
      this.checkProductCode()
      this.resetPagination();
      this.searchQuery = "";
      this.tableData = [];
      this.fetchData()
    }
  },
  mounted() {
    this.checkProductCode()
    this.fetchData();
  },

  mixins: [clientPaginationMixin],
  components: {
    DialogUploadDocument,
    BasePagination,
    RouteBreadCrumb,
    [Scrollbar.name]: Scrollbar,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  }
};
</script>
<style scoped>
.motor-quote-status-pill {
  display: inline-block;
  max-width: 100%;
  padding: 0.28rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  border-radius: 999px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.motor-quote-status-pill--quote-created {
  background: #e3f2fd;
  color: #0d47a1;
}

.motor-quote-status-pill--quote-referred-in-portal {
  background: #fff8e1;
  color: #e65100;
}

.motor-quote-status-pill--quote-declined-in-portal {
  background: #ffebee;
  color: #b71c1c;
}

.motor-quote-status-pill--consent-email-sent {
  background: #b2ebf2;
  color: #006064;
}

.motor-quote-status-pill--sent-to-customer {
  background: #e8f5e9;
  color: #1b5e20;
}

.motor-quote-status-pill--sent-to-broker {
  background: #e0f7fa;
  color: #006064;
}

.motor-quote-status-pill--quote-referred-underwriting {
  background: #fff3e0;
  color: #e65100;
}

.motor-quote-status-pill--quote-declined-underwriting {
  background: #fce4ec;
  color: #880e4f;
}

.motor-quote-status-pill--policy-bound {
  background: #c8e6c9;
  color: #1b5e20;
}

.motor-quote-status-pill--not-complete {
  background: #eceff1;
  color: #546e7a;
}

.motor-quote-status-pill--empty {
  background: #f5f5f5;
  color: #9e9e9e;
}

.motor-quote-status-pill--other {
  background: #eef1f5;
  color: #37474f;
}

.container {
  max-width: 1800px;
  margin: 0px 30px 0px 30px;
}
.expandedPolicy p {
  font-size: 0.9rem;
  color: #000000;
}
.btn-download {
  font-size: 0.9rem;
  margin: 5px;
  min-width: 10em;
}

.btn-download span {
  font-family: sans-serif;
}

.btn-refresh {
  padding: 0.64rem 0.85rem;
  font-size: 1rem;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: none;
}
</style>

<style>
.el-table .cell {
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
  line-height: 23px;
}
</style>
